module.exports = __webpack_public_path__ + "static/media/NoyhGeometric-SemiLight.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NoyhGeometric-SemiLight.otf
// module id = 889
// module chunks = 0